module.exports = __webpack_public_path__ + "img/incendiollamado.93a10fdf.gif";